import { CATEGORIES } from "./constants";

interface ReasonButtonsProps {
  selected: Set<string>;
  onToggle: (category: string) => void;
}

const ReasonButtons: React.FC<ReasonButtonsProps> = ({ selected, onToggle }) => {
  return (
    <div className="verdict-section">
      <div className="verdict-label">Issue</div>
      <div className="verdict-row">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.key}
            type="button"
            className={`reason-btn ${selected.has(cat.key) ? "selected" : ""}`}
            onClick={() => onToggle(cat.key)}
          >
            {cat.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReasonButtons;
